
<div class="panel panel-primary" data-testid="add-house-modal">
    <div class="panel-heading">
      Add House to {{strike.Title}}
    </div>
    <div *ngIf="loadingStrikeHouses === true">
      <div class="col-xs-4"></div>
      <div class="col-xs-4">
        <i class="fa fa-refresh fa-5x fa-spin"></i> <span class="label label-primary">Loading House and its employees...</span>
      </div>
      <div class="col-xs-4"></div>
    </div>
    <div class="panel-body">
      <form class="form-horizontal" role="form">
        <div class="form-group">
          <div class="col-xs-8 selectContainer">
            <label for="selectedHouse" class="control-label">Available Houses</label>
            <select
                [(ngModel)]="selectedHouse"
                class="form-control black"
                id="selectedHouse"
                name="selectedHouse">
              <option *ngFor="let option of allHouses" [ngValue]="option" required>{{option.HouseId+' - '+option.HouseName + ' ['+ option.NoOfEmployees+ ' employees]'}}</option>
            </select>
          </div>
        </div>
      </form>
    </div>
    <!--<div class="alert alert-danger" ng-show="addHouseError">-->
      <!--<h4>{{errText}}</h4>-->
    <!--</div>-->
    <div class="panel-footer clearfix">
      <div class="pull-right">
        <button type="button" class="btn btn-danger" (click)="closeModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="addStrikeHouse()" [disabled]="disableButton">Add House</button>
      </div>
    </div>
  </div>
  
